// Work in canvas coordinates; never resize or move existing artwork.
export function findCopyBounds(source, size, obstacles, area, gap, epsilon = 0.5) {
  const fits = candidate => (
    candidate.left >= area.left - epsilon && candidate.top >= area.top - epsilon &&
    candidate.left + size.width <= area.right + epsilon &&
    candidate.top + size.height <= area.bottom + epsilon &&
    obstacles.every(other => (
      candidate.left + size.width <= other.left + epsilon ||
      candidate.left >= other.left + other.width - epsilon ||
      candidate.top + size.height <= other.top + epsilon ||
      candidate.top >= other.top + other.height - epsilon
    ))
  )
  const clamp = candidate => ({
    left: Math.max(area.left, Math.min(candidate.left, area.right - size.width)),
    top: Math.max(area.top, Math.min(candidate.top, area.bottom - size.height)),
  })
  const adjacent = [
    { left: source.left + source.width + gap, top: source.top },
    { left: source.left, top: source.top + source.height + gap },
    { left: source.left - size.width - gap, top: source.top },
    { left: source.left, top: source.top - size.height - gap },
  ].map(clamp).find(fits)
  if (adjacent) return adjacent

  // At each artwork edge, scan occupied horizontal intervals for an open slot.
  const rows = [...new Set([area.top, ...obstacles.map(o => o.top + o.height + gap)])]
    .filter(top => top >= area.top && top + size.height <= area.bottom + epsilon)
    .sort((a, b) => a - b)
  for (const top of rows) {
    let left = area.left
    const occupied = obstacles.filter(o => (
      top < o.top + o.height - epsilon && top + size.height > o.top + epsilon
    )).sort((a, b) => a.left - b.left)
    for (const other of occupied) {
      if (left + size.width + gap <= other.left + epsilon) break
      left = Math.max(left, other.left + other.width + gap)
    }
    const candidate = { left, top }
    if (fits(candidate)) return candidate
  }
  return null
}
